import cn from "clsx";
import React from "react";
import { useTranslations } from "next-intl";
import { appAppleId, appScheme, checkAndroidWeb, checkIOSWeb } from "@/util/apputil";
import { Button } from "antd";
import Icon from "@/components/common/icon/icon";
import { checkEmpty } from "@/util/stringutil";

export default function Footer({ className }: { className?: string }) {
  const t = useTranslations("footer");
  return (
    <footer className={cn(className, "w-full flex")}>
      <div className="flex py-6 px-6 mx-auto md:px-10 lg:px-16 max-w-7xl  w-full text-center items-center">
        {checkAndroidWeb ? (
          <Button
            href={`intent://open#Intent;scheme=${appScheme};package=site.coffeein.app;end`}
            className="mr-2 min-w-[2rem]"
            icon={<Icon iconType="" iconName="GooglePlayLogo" weight="bold" />}
          >
            {""}
          </Button>
        ) : (
          ""
        )}
        {checkIOSWeb && !checkEmpty(appAppleId) ? (
          <Button
            href="#"
            className="mr-2 min-w-[2rem]"
            icon={<Icon iconType="" iconName="AppleLogo" weight="bold" />}
            onClick={(e) => {
              e.preventDefault();
              const appSchemeUrl = `${appScheme}://open`; // 앱에서 처리할 custom url
              const appId = !checkEmpty(appAppleId) ? appAppleId : "";
              const appStoreURL = "https://apps.apple.com/app/"; // 실제 App Store 주소
              const now = Date.now();
              window.location.href = appSchemeUrl;
              setTimeout(() => {
                if (Date.now() - now < 1500) {
                  if (!checkEmpty(appId)) {
                    window.location.href = appStoreURL + appId;
                  }
                }
              }, 1000);
            }}
          >
            {""}
          </Button>
        ) : (
          ""
        )}
        {t("copyright")}
      </div>
    </footer>
  );
}
